import { waitForDomChangeAsync } from "../../_shared/wait/wait";

export default async function loadLivePersonAsync(){
    require('./livePersonInit');
    return waitForDomChangeAsync(()=> {
        let lpmContainer = document.querySelector('.LPMcontainer')
        let isComplete = !!lpmContainer;
        return isComplete;
    },'body', {childList: true})
}